import React from "react";
import { BookMarked } from "lucide-react";
import { MitigationChip } from "@/components/roles/MitigationChip";

export function SuggestedControls({ controls }) {
    if (!controls || controls.length === 0) return null;
    return (
        <div className="mt-2 pt-2 border-t border-white/5">
            <div className="flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider text-emerald-400/90 mb-1">
                <BookMarked size={10} /> Suggested Mitigation Controls · click for elaborated control &amp; framework mapping
            </div>
            <div className="flex flex-wrap gap-1">
                {controls.map((s) => (
                    <MitigationChip key={s.control_id} suggestion={s} />
                ))}
            </div>
        </div>
    );
}
